import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { formatTable, ReportCacheService } from 'core';
import { map } from 'rxjs/operators';
import { ChartModule } from '@progress/kendo-angular-charts';
import { LsTableComponent } from '../ls-table/ls-table.component';
import { NgFor, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { RevLinescaleComponent } from 'runtime/components/rev-linescale/rev-linescale.component';

@Component({
    selector: 'app-simple',
    templateUrl: './simple.component.html',
    styleUrls: ['./simple.component.scss'],
    standalone: true,
    imports: [NgFor, NgSwitch, NgSwitchCase, LsTableComponent, ChartModule, RevLinescaleComponent, NgSwitchDefault]
})
export class SimpleComponent implements OnInit {

  result: any;
  labelSettings = {
    padding: 3,
    font: '12px Roboto, Arial, sans-serif'
  };


  constructor(
    private rcServ: ReportCacheService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const cacheKey: string = this.route.snapshot.params.cacheKey;
    this.rcServ.getReportData(cacheKey, 'summary').pipe(
      map((result: any[]) => result.map(item => {
        if (item?.type === 'table') {
          return formatTable(item);
        } else if (item.type === 'rating_set') {
          const lsData = item.rs_linescale,
            chart = item.summary_chart;

          return {
            ...item,
            summary_table: formatTable(item.summary_table),
            linescale: {
              ...lsData,
              items: lsData.data.varnames.map(rItemName => {
                const rItem = lsData.data[rItemName];
                return {
                  ...rItem,
                  value: rItem.value / rItem.counts
                }
              }),
              scale_text: lsData.data.scale_text
            },
            summary_chart: {
              ...chart,
              series: chart.series.map(series => series.map(val => Math.round(val)))
            }
          }
        }
        return item;
      }))
    ).subscribe((result: any[]) => {
      this.result = result.filter(item => !!item);
      console.log(this.result);
    })
  }

}
